/**
 * useColorScheme — the resolved 'light' | 'dark' scheme from the web
 * ThemeProvider (mirror of mobile hooks/use-color-scheme.ts, including its
 * 'light' fallback outside the provider).
 */

import { useTheme } from '@/theme/ThemeProvider';
import type { ColorScheme } from '@/theme/tokens';

export function useColorScheme(): ColorScheme {
  try {
    return useTheme().colorScheme;
  } catch {
    // Outside ThemeProvider (e.g. an error boundary fallback).
    return 'light';
  }
}
